import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ResumeListTheatre, ResumeListMusicVideo, ResumeListCommercial, ResumeListEducation, ResumeListTraining, ResumeListVoice, ResumeListSkills } from "../../arrays/ResumeLists";
import CaitlinKlotz_Resume from "../../assets/files/CaitlinKlotz_Resume.pdf";

function Resume() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="resume">
            {/* <h2>Resume</h2> */}
            <section className="bio wrapper clearfix">
                <a className="downloadLink" href={CaitlinKlotz_Resume} download="CAITLIN KLOTZ Resume.pdf">
                    <FontAwesomeIcon
                        icon="fa-solid fa-download"
                        className="icon"
                    />
                    Download Resume
                </a>
                <div>
                    <h2>Theatre</h2>
                    <ul className="resumeGrid">
                        {ResumeListTheatre.map((credit, i) => {
                            return (
                                <li key={i} className="creditContainer theatre">
                                    <p className="project">{credit.project}</p>
                                    <p className="role">{credit.role}</p>
                                    <p className="production">{credit.production}</p>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div>
                    <h2>Music Videos</h2>
                    <ul className="resumeGrid">
                        {ResumeListMusicVideo.map((credit, i) => {
                            return (
                                <li key={i} className="creditContainer musicVideo">
                                    <p className="project">{credit.project}</p>
                                    <p className="role">{credit.role}</p>
                                    <p className="production">{credit.production}</p>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div>
                    <h2>Commercials</h2>
                    <ul className="resumeGrid">
                        {ResumeListCommercial.map((credit, i) => {
                            return (
                                <li key={i} className="creditContainer commercial">
                                    <p className="statement italic">{credit.statement}</p>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div>
                    <h2>Education</h2>
                    <ul className="resumeGrid">
                        {ResumeListEducation.map((credit, i) => {
                            return (
                                <li key={i} className="creditContainer education">
                                    <p className="program">{credit.program}</p>
                                    <p className="instructor">{credit.instructor}</p>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div>
                    <h2>Training</h2>
                    <ul className="resumeGrid">
                        {ResumeListTraining.map((credit, i) => {
                            return (
                                <li key={i} className="creditContainer training">
                                    <p className="program">{credit.program}</p>
                                    <p className="instructor">{credit.instructor}</p>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div>
                    <h2>Voice</h2>
                    <ul className="resumeGrid">
                        {ResumeListVoice.map((credit, i) => {
                            return (
                                <li key={i} className="creditContainer voice">
                                    <p className="program">{credit.program}</p>
                                    <p className="instructor">{credit.instructor}</p>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div>
                    <h2>Special Skills</h2>
                    <ul className="resumeGrid">
                        {ResumeListSkills.map((credit, i) => {
                            return (
                                <li key={i} className="creditContainer skills">
                                    <p className="category"><strong>{credit.category}</strong></p>
                                    <p className="skill">{credit.skill}</p>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </section>
        </div>
    );
};

export default Resume;